import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class UpdateEventCommand implements IMessage {
    id!: Guid;
    townId!: Guid;
    eventTypeId!: Guid;
    startAt!: Date;
    endAt!: Date;
    areDatesValidated!: boolean;

    public constructor(init?: Partial<UpdateEventCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "PUT";

    getUrl = () => `/admin/events/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => {
        return {
            townId: this.townId,
            eventTypeId: this.eventTypeId,
            startAt: this.startAt,
            endAt: this.endAt,
            areDatesValidated: this.areDatesValidated,
        };
    }
}